@if (listItem) {
    <ui-list-view-container class="prevention-list-item">
        <ui-detail-image
            image
            [imagePath]="listItem.imagePath"
        />
        <ui-detail-section class="prevention-list-item__details">
            <ui-detail-tags
                [ariaLabel]="'Kategorien'"
                [tags]="listItem.categories"
            />
            <ui-detail-title [title]="listItem.title"/>
            @if (listItem.shortDescription) {
                <ui-detail-description
                    [htmlDescription]="listItem.shortDescription"
                />
            }
            <p-divider class="prevention-list-item__divider"/>
        </ui-detail-section>

        <div class="prevention-list-item__button-container">
            <p-button
                type="button"
                icon="pi pi-eye"
                class="prevention-list-item__button"
                [attr.aria-label]="'Details anzeigen für ' + listItem.title"
                [attr.aria-expanded]="isVisible()"
                [attr.aria-controls]="'details-dialog-' + listItem.id"
                [label]="'Details anzeigen'"
                (click)="isVisible.set(true)"
            />
        </div>
    </ui-list-view-container>

    <p-dialog
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [closeOnEscape]="true"
        [blockScroll]="true"
        [maximizable]="true"
        [style]="{ width: 'clamp(80vw, 95vw, 800px)', maxWidth: '95vw', minHeight: '50vh' }"
        [attr.id]="'details-dialog-' + listItem.id"
        [attr.aria-labelledby]="'dialog-title-' + listItem.id"
        [attr.aria-describedby]="'dialog-content-' + listItem.id"
        [closeButtonProps]="{
            ariaLabel: 'Details schließen für ' + listItem.title,
            severity: 'secondary',
            variant: 'text',
            rounded: true
         }"
        [(visible)]="isVisible"
        (onHide)="onDialogHide()"
    >
        <ng-template pTemplate="header">
            <h1 class="dialog-title" [attr.id]="'dialog-title-' + listItem.id">{{ listItem.title }}</h1>
        </ng-template>
        <div [attr.id]="'dialog-content-' + listItem.id">
            <ui-prevention-list-item-details
                [mapItem]="listItem"
            />
        </div>
    </p-dialog>
}
